import { render, staticRenderFns } from "./dict_list.vue?vue&type=template&id=f115e49c&scoped=true"
import script from "./dict_list.vue?vue&type=script&lang=js"
export * from "./dict_list.vue?vue&type=script&lang=js"
import style0 from "./dict_list.vue?vue&type=style&index=0&id=f115e49c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f115e49c",
  null
  
)

export default component.exports